// src/components/Layout/PublicLayout.js

import React from 'react';
import { Outlet } from 'react-router-dom';
import styled from 'styled-components'; // 1. Import styled-components
import Navbar from '../navbar/Navbar';
import Footer from '../footer/Footer';

// 2. Create a styled main element
//    Replace '80px' with the actual height of your Navbar.
const MainContentWrapper = styled.main`
  padding-top: 80px; 
`;

const PublicLayout = () => {
  return (
    <>
      <Navbar />
      {/* 3. Use the new styled wrapper instead of a plain <main> tag */}
      <MainContentWrapper>
        <Outlet />
      </MainContentWrapper>
      <Footer />
    </>
  );
};

export default PublicLayout;